/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import style from "../index.module.scss";
import Cancel from "@mui/icons-material/Cancel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Button,
  InputLabel,
  IconButton,
  FormControl,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { SvgPath } from "../assets/index";
import { useEffect, useState } from "react";
import  PasswordError  from "@/app/csr-src/assets/icons/passwordError.svg";
import  PasswordSuccess  from "@/app/csr-src/assets/icons/passwordSuccess.svg";
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25426";
interface PasswordInputProps {
  onSubmit: (password: string) => void;
}

// eslint-disable-next-line react/prop-types
const CreatePasswordDom: React.FC<PasswordInputProps> = ({ onSubmit }) => {
  const [password, setPassword] = useState(""); // 初始密码
  const [confirmPassword, setConfirmPassword] = useState(""); // 再次输入的密码
  const [error, setError] = useState(""); // 初始密码提示
  const [errorConfirmText, setErrorConfirm] = useState(""); // 再次输入密码提示
  const [showPassword, setShowPassword] = useState(false); // 查看密码
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 查看输入密码
  const [submitFlag, setSubmitFlag] = useState(true); // 按钮状态
  const [focused, setFocused] = useState(false); // 聚焦判断

  const [passwordMsgFlag, setPasswordMsgFlag] = useState(false); // 初始密码错误提示元素显示
  const [minimumMsg, setMinimumMsg] = useState(false); // 密码长度提示
  const [atLeastOneNumberMsg, setAtLeastOneNumberMsg] = useState(false); // 最少一个数字
  const [atLeastOneLetterMsg, setAtLeastOneLetterMsg] = useState(false); // 最少一个字母
  const [confirmPasswordMsgFlag, setConfirmPasswordMsgFlag] = useState(false); // 再次输入的密码
  useEffect(()=> {
    sendPv.NewPassword()
  }, [])
  useEffect(() => {
    if (minimumMsg && atLeastOneNumberMsg && atLeastOneLetterMsg && password == confirmPassword) {
      setSubmitFlag(false);
    } else {
      setSubmitFlag(true);
    }
  }, [password, minimumMsg, atLeastOneNumberMsg, atLeastOneLetterMsg, confirmPassword]);
  useEffect(() => {
    if (password.trim() !== "" || /^\s+$/.test(password)) {
      setPasswordMsgFlag(true);
      validatePassword(password);
      if (/[0-9]/.test(password) && /[a-zA-Z]/.test(password) && password.length >= 8) {
        setError("");
      }
    } else {
      setMinimumMsg(false);
      setAtLeastOneNumberMsg(false);
      setAtLeastOneLetterMsg(false);
    }
    if (confirmPassword) {
      if (password == confirmPassword) {
        setConfirmPasswordMsgFlag(true);
        setErrorConfirm("");
      } else {
        setConfirmPasswordMsgFlag(false);
        setErrorConfirm("Passwords must match"); // 两次输入的密码不一致
      }
    } else if (confirmPassword == "" && password == "") {
      setConfirmPasswordMsgFlag(false);
      setErrorConfirm("");
    }
  }, [password]);

  useEffect(() => {
    if (password && confirmPassword) {
      if (confirmPassword !== password) {
        setErrorConfirm("Passwords must match"); // 两次输入的密码不一致
        setConfirmPasswordMsgFlag(false);
      } else {
        setErrorConfirm("");
        setConfirmPasswordMsgFlag(true);
      }
    } else if (password == "" && confirmPassword) {
      setErrorConfirm("Passwords must match");
    } else if (password == "" && confirmPassword == "") {
      setErrorConfirm("");
    } else if (password && confirmPassword == "") {
      setErrorConfirm("Passwords must match");
      setConfirmPasswordMsgFlag(false);
    }
  }, [confirmPassword]);
  // 输入密码 onChang 事件
  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPassword(value);
  };
  // 再次输入密码 onChang 事件
  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setConfirmPassword(value);
    validateConfirmPassword(value);
  };

  // 输入密码校验规则
  const validatePassword = (value: string) => {
    if (!/[0-9]/.test(value)) {
      setError("At least one number");
      setAtLeastOneNumberMsg(false);
    } else {
      setAtLeastOneNumberMsg(true);
    }
    if (!/[a-zA-Z]/.test(value)) {
      setError("At least one letter");
      setAtLeastOneLetterMsg(false);
    } else {
      setAtLeastOneLetterMsg(true);
    }
    if (value.length < 8) {
      setError("8 characters minimum");
      setMinimumMsg(false);
    } else {
      setMinimumMsg(true);
    }
  };
  // 判断是否和初始密码一样
  const validateConfirmPassword = (value: string) => {
    if (password !== value) {
      setErrorConfirm("Passwords must match");
    } else {
      setErrorConfirm("");
    }
  };
  // 点击 submit
  const handleSubmit = () => {
    sendClickTrack.NewPassword_Save()
    if (!error) {
      onSubmit(password);
    }
  };
  // 查看/隐藏密码
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  // 查看/隐藏二次密码
  const handleShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  // 清空密码
  const closePassword = () => {
    setError("");
    setPassword("");
    setSubmitFlag(true);
  };
  // 清空二次密码
  const closeConfirmPassword = () => {
    setConfirmPassword("");
    setErrorConfirm("");
    setSubmitFlag(true);
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleFocus = () => {
    setFocused(true);
  };
  const handleBlur = () => {
    setFocused(false);
  };

  const successSvg = (
    <>
      <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* eslint-disable-next-line react/no-unknown-property */}
        <path fill-rule="evenodd" clip-rule="evenodd" d={SvgPath.d6} fill="#269636" />
      </svg>
    </>
  );

  const errorSvg = (
    <>
      <svg
        width="11"
        height="10"
        viewBox="0 0 11 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* eslint-disable-next-line react/no-unknown-property */}
        <path fill-rule="evenodd" clip-rule="evenodd" d={SvgPath.d7} fill="#FF0F23" />
      </svg>
    </>
  );

  return (
    <div className={style.createPasswordWrap}>
      {/* 头部盒子 */}
      <div className={style.title__text}>Create a new password</div>
      <svg
        className={style.titleText}
        width="435"
        height="33"
        viewBox="0 0 435 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={SvgPath.d2} fill="#1A1A1A" />
      </svg>
      {/* 密码规则 */}
      {/* <svg
        className={style.contain}
        width="470"
        height="108"
        viewBox="0 0 470 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d={SvgPath.d3} fill="#1A1A1A" />
        <path d={SvgPath.d4} fill="#505259" />
      </svg> */}
      {/* Input 输入框盒子 */}
      <div className={style.InputBox}>
        <FormControl
          variant="outlined"
          error={!!error}
          color="info"
          sx={{
            width: "450px",
            "&.MuiOutlinedInput-root": {
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: focused
                  ? "1px solid #1a1a1a !important"
                  : "1px solid border-color: rgba(0, 0, 0, 0.23); !important",
              },
            },
          }}
        >
          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            label="Password"
            value={password}
            type={showPassword ? "password" : "text"}
            onChange={handlePasswordChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            autoComplete="new-password"
            endAdornment={
              <InputAdornment position="end">
                {password ? (
                  <>
                    <IconButton onClick={closePassword}>
                      <Cancel sx={{ fontSize: 18 }} />
                    </IconButton>
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                    >
                      {showPassword ? (
                        <VisibilityOff sx={{ fontSize: 18 }} />
                      ) : (
                        <Visibility sx={{ fontSize: 18 }} />
                      )}
                    </IconButton>
                  </>
                ) : null}
              </InputAdornment>
            }
          />
          {/* <FormHelperText id="component-error-text">{error}</FormHelperText> */}
        </FormControl>

        {passwordMsgFlag ? (
          <ul className={style.errorPasswordBox}>
            <li className={minimumMsg ? style.successMsg : style.errorMsg}>
              {minimumMsg ? successSvg : errorSvg}&nbsp; 8 characters minimum
            </li>
            <li className={atLeastOneNumberMsg ? style.successMsg : style.errorMsg}>
              {atLeastOneNumberMsg ? successSvg : errorSvg}&nbsp; At least one number
            </li>
            <li className={atLeastOneLetterMsg ? style.successMsg : style.errorMsg}>
              {atLeastOneLetterMsg ? successSvg : errorSvg}&nbsp; At least one letter
            </li>
          </ul>
        ) : (
          ""
        )}

        <FormControl
          color="info"
          error={!!errorConfirmText}
          sx={{ width: "450px" }}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            label="Confirm Password"
            value={confirmPassword}
            type={showConfirmPassword ? "password" : "text"}
            onChange={handleConfirmPasswordChange}
            autoComplete="new-password"
            endAdornment={
              <InputAdornment position="end">
                {confirmPassword ? (
                  <>
                    <IconButton onClick={closeConfirmPassword}>
                      <Cancel sx={{ fontSize: 18 }} />
                    </IconButton>
                    <IconButton
                      onClick={handleShowConfirmPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff sx={{ fontSize: 18 }} />
                      ) : (
                        <Visibility sx={{ fontSize: 18 }} />
                      )}
                    </IconButton>
                  </>
                ) : null}
              </InputAdornment>
            }
          />
          {
            !!errorConfirmText && (
              <div className={style.error__Text}>
                {confirmPasswordMsgFlag ? <PasswordSuccess /> : <PasswordError />}
                {confirmPasswordMsgFlag ? (
                  <span className={style.errorText}>Passwords must match</span>
                ) : (
                  <span>{errorConfirmText}</span>
                )}
              </div>
            )
            // <FormHelperText sx={{ color: "#FF0F23" }}>
            // </FormHelperText>
          }
          {confirmPasswordMsgFlag && (
            <div className={style.error__Text}>
              <PasswordSuccess />
              <span className={style.errorText}>Passwords must match</span>
            </div>
          )}
        </FormControl>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitFlag}
          exptag={"exp|" + EXPOSURE_RECORD.NewPassword_SaveExpo}
          data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
          sx={{
            width: "450px",
            height: "48px",
            fontSize: "20px",
            backgroundColor: "#FF0F23", // 自定义背景颜色
            color: "#fff", // 自定义文字颜色
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FF475D", // 悬停时的背景颜色
            },
            "&.Mui-disabled": {
              backgroundColor: "#FF9FA7",
              color: "#fff",
            },
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CreatePasswordDom;
